import * as jQuery from 'jquery';

import './libs/owlCarousel/owl.carousel.min';
import './libs/niceSelect/js/jquery.nice-select.min';
import './libs/magnificPopup/jquery.magnific-popup.min';
import * as skrollr from './libs/scrollr/skrollr.min';
import './libs/fancybox/jquery.fancybox.min';
import './libs/inputmask/inputmask';
import './components/equalWidths';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui-touch-punch/jquery.ui.touch-punch.min';
import './libs/scrollbar/jquery.scrollbar.min';

import mobileDevices from './components/mobile-devices';

import tabs from './components/tabs';
import dropdown from './components/dropdown';
import accordion from './components/accordion';
import stickyHeader from './components/sticky-header';
import hamburgerMenu from './components/menu';
import materials from './components/materials';
import productModel from './components/product-model';
import defaultSlider from './components/default_slider';
import scrollingSlider from './components/scrolling-slider';
import navSlider from './components/nav_slider';
import makePopup from './components/make-popup';
//import pagination from './components/pagination';
import Filter from './components/filter';
import search from './components/search';
import scrollToNext from './components/scroll-to-next';
import scrollToElement from './components/scroll-to-element';
import ourProductsSlider from './components/our-products-slider';
import map from './components/maps';
import dealersMap from './components/map-dealers';
import './components/form-antispam';
import './components/form-location';
import PostGrid from './components/grid/grid';
import nonAjaxGrid from './components/grid/non-ajax-grid';
import Cookie from './components/cookie';
import model from './components/3d/model'
import heroSlider from './components/hero-slider'
import AOS from 'aos';
import niceScroll from 'jquery.nicescroll';
import './components/form-success';
import './components/form-gtm';
import './components/ringostat-remake';
import Blazy from 'blazy'
import count_num from './components/count-num';
import YtApiPlayer from './components/yt-api-player';
import ringostat_remake from './components/ringostat-remake';
import make_uppercase from './components/make_uppercase';
import model_img from './components/3d/model_img';
import countdownEvent from './components/countdown-event';
import ringoPhoneMutations from './components/ringo-phone-mutations';
import jivositeRemake from './components/jivosite-remake';
import furnitureTypeCatalog from './components/furniture-type-catalog';
import ConfiguratorStep2 from './components/configurator/configurator-step-2';
import configuratorPage from './components/configurator/configurator-page';
import scrollbar from './components/scrollbar';
import detectedScrollBlock from './components/pos-blocks'
import customRadio from './components/form/radio'


/*pages*/
import catalog from './components/pages/catalog';
import './components/pages/product';
import showrooms from './components/pages/showrooms';
import './components/pages/home'
import ConfiguratorCanvas from "./components/configurator/canvas/ConfiguratorCanvas";

window.$ = window.jQuery = jQuery.default;

((html) => {
    html.className = html.className.replace(/\bno-js\b/, 'js');
})(document.documentElement);

$(() => {

     /**
     * Number.prototype.format(n, x, s, c)
     * 
     * @param integer n: length of decimal
     * @param integer x: length of whole part
     * @param mixed   s: sections delimiter
     * @param mixed   c: decimal delimiter
     */
    Number.prototype.format = function(n, x, s, c) {
        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = this.toFixed(Math.max(0, ~~n));

        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };

    furnitureTypeCatalog();
    countdownEvent();
    jivositeRemake();
    ringoPhoneMutations('.ringo-phone');
    mobileDevices();
    scrollbar('.js-materials');
    scrollbar('.na-js-grid-content-outer');
    scrollbar('.js-pre-order-content', '.js-pre-order-scroll_y');
    customRadio();

    if($('#configurator-canvas').length > 0) {
        setTimeout(function () {
            new ConfiguratorCanvas({});
            configuratorPage();
            $('.js-materials .material__item').on('click', function(){
                $(this).parents('.js-materials').find('.material__item.is-current').removeClass('is-current');
                $(this).addClass('is-current');
            })
        }, 0);
    }

    if($('.js-configurations').length > 0) {
        new ConfiguratorStep2({});
    }

    let words_make_uppercase = [
        'Blanche',
        'Vivo',
        'Circle',
        'Alba',
        'Riccarda',
        'Doppio',
        'Puff twice',
        'Puff one',
        'Ria',
        'Karrera',
        'Moko',
        'Woody t',
        'Riviera t',
        'Soho t',
        'Palio t',
        'Palio T',
        'Carre',
        'Corto',
        'Lungo',
        'Quadro',
        'Sphera',
        'Corso',
        'Tati',
        'Dionigi',
        'Too night',
        'Eterna',
        'Limura',
        'Vogue',
        'Laval',
        'Nino',
        'Sani',
        'Nubi',
        'Ilaria',
        'Habana',
        'Melia',
        'La isla',
        'Milton',
        'Parma',
        'Sky',
        'Ipsoni',
        'Soho',
        'Moon',
        'Appiani',
        'Ermes',
        'Esse',
        'Tutto',
        'Cliff',
        'Alfinosa',
        'Linda',
        'Orsi',
        'Katarina',
        'Aura',
    ];

    // mapsIframeCustomization('.js-show-rooms-single-3d');

    make_uppercase(words_make_uppercase);
    model();
    model_img();

    setTimeout(function () {
        ringostat_remake();
    }, 3000);


    /*if(wpml_lang === 'ru' || wpml_lang === 'uk') {
        $('.input-tel, [type="tel"]').mask("+38(999)999-9999", {autohide: false});
    } else if (wpml_lang === 'en') {
        $('.input-tel, [type="tel"]').mask("(999) 999-9999", {autohide: false});
    }
    else {
        $('.input-tel, [type="tel"]').mask("+999(999)999-9999", {autohide: false});
    }*/

    $('.js-nicescroll').niceScroll({
        cursorwidth: "2px",
        cursorborder: "0",
        autohidemode: false,
        scrollspeed: 40,
        mousescrollstep: 20,
        background: "#dadada",
        railoffset: {
            top: 15,
            left: 33
        }
    });

    /*YouTube iframe API connect*/
    let tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    /*YouTube iframe API connect*/

    new YtApiPlayer({
        player_id: 'product-video',
        video_id: 'from_data',
        play_button: '.js-video-play'
    });

    $('.js-callback').magnificPopup({
        type: 'inline',
        preloader: false
    });

    new Filter('.filter');

    $('[data-fancybox="gallery"]').fancybox({
        infobar: false,
        buttons: [
            'zoom',
            'close',
        ],
    });

    makePopup('.js-popup', 'inline');


    tabs({
        work_with: 'data'
    });
    dropdown();
    if ($('.product-constructor').length > 0) materials();
    stickyHeader();
    productModel();
    scrollToElement();
    search('.js-search');
    scrollToNext('.js-scroll-down');
    accordion('.accordion__head', '.accordion__item');
    accordion('.options-section__title', '.options-section', {
        item: '.options-section',
        body: '.options-section__content',
        active_class: 'active'
    });
    accordion('.js-configurator-page-filters-accordion-title', '.js-configurator-page-filters-accordion', {
        item: '.js-configurator-page-filters-accordion',
        body: '.js-configurator-page-filters-accordion-body',
        active_class: 'active'
    });
    hamburgerMenu('.js-menu', '.js-hamburger');
    $('.js-styled-select').niceSelect();
    catalog();
    showrooms();
    count_num('.js-count-num', 1500);

    defaultSlider('.js-slider');

    defaultSlider('.js-articles-slider');

    defaultSlider('.js-slider-clients', {
        items: 1,
        loop: false,
        margin: 18,
        nav: false,
        dots: true,
        dotsSpeed: 800,
        dragEndSpeed: 700,
    });
    defaultSlider('.js-slider-featured-news', {
        items: 1,
        loop: true,
        dots: true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        autoplayHoverPause: true,
        autoplay: true,
        autoplayTimeout: 5000,
    });

    defaultSlider('.js-shares-slider', {
        items: 1,
        nav: false,
        dots: true,
        loop: true,
        autoHeight: false,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        autoplay: true,
        autoplayTimeout: 5000,
    });

    heroSlider('.js-hero-slider', {
        items: 1,
        nav: false,
        dots: true,
        loop: false,
        touchDrag: false,
        mouseDrag: false,
        autoHeight: false,
        animateOut: 'fadeOut',
        animateIn: false,

        autoplay: true,
        autoplayTimeout: 5000,
        autoplaySpeed: 1000,
    });

    defaultSlider('.js-filter-category', {
        items: 6,
        nav: false,
        dots: false,
        loop: false,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        responsive: {
            1024: {items: 6},
            768: {items: 5},
            600: {items: 4},
            480: {items: 3},
            0: {items: 2},
        }
    });
    defaultSlider('.js-slider-examples', {
        loop: false,
        items: 3,
        margin: 18,
        nav: true,
        responsive: {
            992: {
                items: 3
            },
            768: {
                items: 2
            },
            0: {
                items: 1
            }
        }
    });

    navSlider('.js-articles-slider-nav', {
        items: 3,
        margin: 18,
        loop: true,
        responsive: {
            768: {
                items: 3
            },
            0: {
                items: 1
            }
        }
    });

    navSlider('.js-slider-2d-3d', {
        items: 4,
        loop: false,
        margin: 18,
        nav: true,
        navSpeed: 700,
        dragEndSpeed: 500,
        navText: [
            '<img src="/wp-content/themes/classy/dist/img/icons/angle-left.svg" alt="left"/>',
            '<img src="/wp-content/themes/classy/dist/img/icons/angle-right.svg" alt="right"/>'
        ],
        responsive: {
            1200: {
                items: 4
            },
            992: {
                items: 3
            },
            768: {
                items: 2
            },
            0: {
                items: 1
            }
        }
    });

    defaultSlider('.js-model-slider', {
        items: 3,
        nav: true,
        dots: true,
        responsive: {
            992: {
                items: 3
            },
            768: {
                items: 2
            },
            0: {
                items: 1
            }
        }
    });

    defaultSlider('.js-slider-product-details', {
        items: 1,
        nav: false,
        dots: true,
    });

    defaultSlider('.js-related-slider, .js-big-product-slider, .js-product-slider', {
        items: 3,
        loop: true,
        nav: true,
        dots: false,
        responsive: {
            1100: {
                items: 3,
            },
            768: {
                items: 2,
            },
            0: {
                items: 1,
                nav: false,
                dots: true,
            }
        }
    });

    if ($('.na-js-grid').length > 0) {
        new nonAjaxGrid({
            grid_wrapper : '.na-js-grid',
            grid : '.na-js-grid-content',
            tags: '.na-js-tag'
        });
    }

    if ($('.js-grid').length > 0) {
        new PostGrid({
            grid: '.js-grid-content',
            tag_type: 'tag',
            taxonomy_name: 'news_type',
            selection: 'singular',
            wide_elements: true
        });
    }

    if ($('.js-grid-showrooms').length > 0) {
        new PostGrid({
            post_type: 'show-rooms',
            grid_wrapper: '.js-grid-showrooms',
            grid: '.js-grid-content',
            taxonomy_name: 'locations',
            acf_tags_key: 'show_room_country',
            wide_elements: true,
            selection: 'singular',
            group_by_taxonomy: 1
        });
    }

    if ($('.js-models-grid').length > 0) {
        new PostGrid({
            post_type: 'models',
            grid_wrapper: '.js-models-grid',
            grid: '.js-grid-content',
            tag_type: 'tag',
            taxonomy_name: 'type',
            tag_display: 'select',
            wide_elements: false,
            models: true,
            item: '.ajax-item',
            gutter: 0,
            post_count: 16,
            group_by_taxonomy: 0
        });
    }

    if ($('.js-catalog-grid').length > 0) {
        new PostGrid({
            post_type: 'product',
            grid_wrapper: '.js-catalog-grid',
            grid: '.js-grid-content',
            tag_type: 'tag',
            taxonomy_name: 'product_category',
            wide_elements: false,
            item: '.ajax-item',
            rearrange_on_click: '.js-rearrange',
            gutter: 0,
            multiple_relation: 'and',
            post_count: 100,
            catalog: true,
            masonry: false,
        });
    }

  scrollingSlider('.js-scrolling-gallery', {
    loop: true,
    count_rearrange: true
  });
  scrollingSlider('#js-scrolling-interior', {
    count_rearrange: true
  });
  scrollingSlider('#js-scrolling-carousel', {
    count_rearrange: true
  });


  window.onload = () => {
    setTimeout(function () {
      let window_height = $(window).height();
      let offset = window_height / 4;

      $('.aos-animation:not([data-aos])').attr('data-aos', 'fade-up');
      $('.aos-animation:not([data-aos-anchor-placement])').attr('data-aos-anchor-placement', 'top-bottom');
      $('.aos-animation:not([data-aos-offset])').attr('data-aos-offset', offset);

      AOS.init({
        duration: 800,
      });

    }, 1000);
  }
  setTimeout(function () {
    if (typeof skrollr !== 'undefined') {
      let scr = skrollr.init({
        forceHeight: false,
        mobileCheck: () => false,
        easing: 'ease',
        smoothScrolling: false,
        smoothScrollingDuration: 50,
      });
    }
  }, 100);

    const $contactsMap = $('#contacts-map');
    if ($contactsMap.length > 0) {
        const lat = $contactsMap.attr('data-lat');
        const lng = $contactsMap.attr('data-lng');
        map('contacts-map', lat, lng);
    }

    const $map = $('#map');
    if ($map.length > 0) {
        const lat = $map.attr('data-lat');
        const lng = $map.attr('data-lng');

        const popupWindow = $('.google-map-info-wrapper').html();

        map('map', lat, lng, popupWindow);
    }

    const $dealersMap = $('#dealers-map');
    if ($dealersMap.length > 0) {

        const lat = $dealersMap.attr('data-lat');
        const lng = $dealersMap.attr('data-lng');

        const $dealersMapItems = $('.dealers-map-list__item');

        let arrayTemp = [];
        let arrayLocations = [];

        $($dealersMapItems).each(function () {
            const info = $(this).attr("data-info");
            const lat = $(this).attr("data-lat");
            const lng = $(this).attr("data-lng");
            const city = $(this).attr("data-city");
            const imgUrl = $(this).attr("data-img-url");
            const address = $(this).attr("data-address");
            const telephone = $(this).attr("data-tel");
            const markerUrl = $(this).attr("data-marker-url");

            if (info) {
                arrayTemp.push(info, lat, lng, city, imgUrl, address, telephone, markerUrl);
            } else {
                arrayTemp.push(info, lat, lng);
            }

            arrayLocations.push(arrayTemp);

            arrayTemp = [];

        });

        dealersMap('dealers-map', lat, lng, arrayLocations);
    }

    // For image preload: add b-lazy class and data-src attribute to div or img
    window.bLazy = new Blazy({
        success: function (e) {
            setTimeout(() => {
                // Apply transition effects after image loaded
                $(e).parent().removeClass('b-lazy-wrapper');
            }, 0);
        },
    });

    /**
     * Responsive video block
     *
     * @param {Object} args
     */
    const responsiveVideo = function responsiveVideo(args) {
        const width = args.window.width();
        const height = args.window.height();
        const totalHeight = args.adminBar.outerHeight() + args.header.outerHeight() + args.videoBlock.outerHeight() + args.scrollHeightOffset + args.spaceHeaderContent;
        const videoHeight = height - args.adminBar.outerHeight() - args.spaceHeaderContent - args.header.outerHeight() - args.scrollHeightOffset;

        // console.log(height, totalHeight);

        if (width > 900 && width > height && height < totalHeight) {
            args.videoBlock.css('height', videoHeight);
        } else if(width > 900 && height > totalHeight && height < 915) {
            args.videoBlock.css('height', videoHeight);
        } else {
            args.videoBlock.css('height', '');
            //args.videoBlock.css('max-height', '300');
        }
    };

    let args = {
        window: $(window),
        header: $('.js-header'),
        adminBar: $('#wpadminbar'),
        videoBlock: $('.section-heading--video-bg .content'),
        scrollHeightOffset: 80,
        spaceHeaderContent: 0,
    };

    responsiveVideo(args);

    $(window).on('resize', () => {

        responsiveVideo(args);
    });

    const isMacLike = /(Mac)/i.test(navigator.platform);
    if(isMacLike) {
        

    }
});
